import type { IValidator } from './IValidator';

export class GenderValidator implements IValidator {
    status: string = '';
    statusType: 'info' | 'warning' | 'error' | 'na' = 'error';
    value?: string;
    validGenderValues: string[] = [];

    public constructor(genderValues: string[]) {
        this.validGenderValues = genderValues.map((v) => v.toLowerCase());
    }
    Status(): string {
        return this.status;
    }

    StatusType(): 'info' | 'warning' | 'error' | 'na' {
        return this.statusType;
    }

    Value(): string {
        return this.value as string;
    }

    Validate(cellvalue: string): boolean {
        if (!this.validGenderValues.includes(cellvalue.toLowerCase())) {
            this.status = 'gendervalidator.unknowngender';
            this.statusType = 'error';
            return false;
        }
        return true;
    }
}
